import Vue from 'vue'
import request from '@/utils/request'

export function loginApi (data) {
  return request({
    url: Vue.prototype.$cwApiBaseUrl + '/api/user/login.do',
    method: 'POST',
    data
  })
}

export function forgotPasswordApi (email, data) {
  return request({
    url: Vue.prototype.$cwApiBaseUrl + `/api/user/forgotPassword.do?email=${email}`,
    method: 'POST',
    data
  })
}

export function registerApi (data) {
  return request({
    url: Vue.prototype.$cwApiBaseUrl + '/api/user/register.do',
    method: 'POST',
    data
  })
}

export function getMemberMyFavouriteApi () {
  return request({
    url: Vue.prototype.$cwApiBaseUrl + '/api/Member/MyFavourite.do',
    method: 'GET'
  })
}

export function getUserApi () {
  return request({
    url: Vue.prototype.$cwApiBaseUrl + '/api/user.do',
    method: 'GET'
  })
}

export function getMemberTxnHistoryApi () {
  return request({
    url: Vue.prototype.$cwApiBaseUrl + '/api/Member/TxnHistory.do',
    method: 'GET'
  })
}

export function getMemberInfoApi () {
  return request({
    url: Vue.prototype.$cwApiBaseUrl + '/api/Member/MemberInfo.do',
    method: 'GET'
  })
}

export function updateMemberInfoApi (data) {
  return request({
    url: Vue.prototype.$cwApiBaseUrl + '/api/Member/MemberInfo.do',
    method: 'POST',
    data
  })
}

export function updatePasswordApi (data) {
  return request({
    url: Vue.prototype.$cwApiBaseUrl + '/api/Member/ChangePassword.do',
    method: 'POST',
    data
  })
}

// 获取 personal notice 数据
export function getPersonalNoticesApi () {
  return request({
    url: '/api/user/personalNotices.do',
    method: 'POST'
  })
}

// 将 personal notice设置成已读
export function setReadPersonalNoticesApi (data) {
  return request({
    url: '/api/user/personalNotice/read.do',
    method: 'POST',
    data
  })
}
